import { useSelector } from 'react-redux'
import Immutable from 'immutable'

import { buildThemeVarsCss } from '../../utils/themes'
import { selectThemeSettings } from '../store/utils'

/**
 * Renders an inline `<style>` with CSS custom property declarations for the current theme
 * settings, including pre-computed contrast color values.
 */
export function ThemeStyleVariables() {
  const themeSettings = useSelector<State, ImmutableMap | undefined>(selectThemeSettings)
  const themeName = useSelector<State, string>((state) => state.getIn(['shop', 'theme', 'name']))
  const contrastColorExpressionMap = useSelector<State, ImmutableMap>((state) =>
    state.get('themeContrastColorExpressions', Immutable.Map()),
  )
  const themeSettingsSchema = useSelector<State, Immutable.List<any> | undefined>((state) =>
    state.get('themeSettingsSchema'),
  )
  const defaultThemeSettings = useSelector<State, ImmutableMap | undefined>((state) =>
    state.get('defaultThemeSettings'),
  )

  if (!themeSettings || !themeSettingsSchema || !defaultThemeSettings) return null

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: buildThemeVarsCss(
          themeSettingsSchema.toJS(),
          defaultThemeSettings.toJS(),
          themeName,
          themeSettings.toJS(),
          contrastColorExpressionMap.toJS() as Record<string, string>,
        ),
      }}
    />
  )
}
